import { Link } from "react-router-dom";
import { useState } from "react";
import AgeVerification from "../AgeVerification/AgeVerification";
import "./Footer.css";

export default function Footer() {
  const [showAgeModal, setShowAgeModal] = useState(false);

  const handleDisclaimerClick = (e) => {
    e.preventDefault();
    setShowAgeModal(true);
  };

  // Display only - this popup re-shows the disclaimer text and must not write
  // the verification flag, or reading it here would suppress the entry gate
  // in UserApp for the rest of the tab session
  const handleAgeConfirm = () => {
    setShowAgeModal(false);
  };

  const handleAgeDeny = () => {
    setShowAgeModal(false);
    // Redirect or show message for underage users
    window.location.href = 'https://www.google.com';
  };
  return (
    <footer
      className="site-footer"
      style={{
        background: "linear-gradient(135deg, rgba(8,12,24,0.98) 0%, rgba(12,16,28,0.95) 100%)",
        backdropFilter: "blur(24px)",
        borderTop: "1px solid rgba(0, 255, 255, 0.12)",
        marginTop: "auto",
        color: "#E5E7EB",
        boxShadow: "0 -12px 40px rgba(0, 0, 0, 0.4)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Premium gradient overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "2px",
          background: "linear-gradient(90deg, transparent, rgba(0, 255, 255, 0.4), transparent)",
        }}
      />
      
      {/* Main Content Container */}
      <div className="site-footer__grid">
        {/* Brand Section */}
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {/* Logo */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src="/chilltree-images/chilltree-logo1.png"
                alt="Chilltree Logo"
                style={{
                  height: "95px",
                  width: "auto",
                  filter: "brightness(0) invert(1)",
                  opacity: 0.95,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.filter = "brightness(0) invert(1) drop-shadow(0 4px 12px rgba(0, 230, 230, 0.4))";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.filter = "brightness(0) invert(1)";
                }}
              />
            </div>
            
            {/* Brand Description */}
            <div className="site-footer__brand-desc" style={{ maxWidth: "300px" }}>
              <p style={{
                color: "#CBD5F5",
                fontSize: "16px",
                lineHeight: "1.7",
                fontFamily: "Inter, system-ui, sans-serif",
                fontWeight: "500",
                margin: 0,
                letterSpacing: "0.02em",
                textShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}>
                Premium wellness solutions crafted with precision and care.
              </p>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#E5E7EB",
              textTransform: "uppercase",
              letterSpacing: "0.15em",
              margin: "0 0 16px 0",
              fontFamily: "Inter, system-ui, sans-serif",
            }}
          >
            Quick Links
            <div 
              style={{
                width: "32px",
                height: "3px",
                background: "linear-gradient(90deg, #00E6E6, #00B8D9)",
                marginTop: "6px",
                borderRadius: "2px",
                boxShadow: "0 2px 8px rgba(0, 230, 230, 0.3)",
              }}
            />
          </h3>
          <nav style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {[
              { to: "/", label: "Home" },
              { to: "/products", label: "Products" },
              { to: "/stores", label: "Store Locator" },
              { to: "/labs", label: "Download Reports" },
            ].map((link) => (
              <Link
                key={link.label}
                to={link.to}
                style={{
                  textDecoration: "none",
                  color: "#CBD5F5",
                  fontSize: "15px",
                  transition: "all 0.3s ease",
                  fontFamily: "Inter, system-ui, sans-serif",
                  fontWeight: "500",
                  letterSpacing: "0.02em",
                  padding: "6px 0",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#00E6E6";
                  e.target.style.transform = "translateX(4px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#CBD5F5";
                  e.target.style.transform = "translateX(0)";
                }}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        {/* Company */}
        <div>
          <h3
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#E5E7EB",
              textTransform: "uppercase",
              letterSpacing: "0.15em",
              margin: "0 0 16px 0",
              fontFamily: "Inter, system-ui, sans-serif",
            }}
          >
            Company
            <div 
              style={{
                width: "32px",
                height: "3px",
                background: "linear-gradient(90deg, #00E6E6, #00B8D9)",
                marginTop: "6px",
                borderRadius: "2px",
                boxShadow: "0 2px 8px rgba(0, 230, 230, 0.3)",
              }}
            />
          </h3>
          <nav style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {[
              { to: "/about", label: "About" },
              { to: "/contact", label: "Contact" },
              { to: "/faq", label: "FAQ" },
              { to: "/disclaimer", label: "21+ Disclaimer", onClick: handleDisclaimerClick },
            ].map((link) => (
              link.onClick ? (
                <button
                  key={link.label}
                  className="site-footer__text-link-btn"
                  onClick={link.onClick}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textDecoration: "none",
                    color: "#CBD5F5",
                    fontSize: "15px",
                    transition: "all 0.3s ease",
                    fontFamily: "Inter, system-ui, sans-serif",
                    fontWeight: "500",
                    letterSpacing: "0.02em",
                    padding: "6px 0",
                    textAlign: 'left',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#00E6E6";
                    e.target.style.transform = "translateX(4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#CBD5F5";
                    e.target.style.transform = "translateX(0)";
                  }}
                >
                  {link.label}
                </button>
              ) : (
                <Link
                  key={link.label}
                  to={link.to}
                  style={{
                    textDecoration: "none",
                    color: "#CBD5F5",
                    fontSize: "15px",
                    transition: "all 0.3s ease",
                    fontFamily: "Inter, system-ui, sans-serif",
                    fontWeight: "500",
                    letterSpacing: "0.02em",
                    padding: "6px 0",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#00E6E6";
                    e.target.style.transform = "translateX(4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#CBD5F5";
                    e.target.style.transform = "translateX(0)";
                  }}
                >
                  {link.label}
                </Link>
              )
            ))}
          </nav>
        </div>

        {/* Contact */}
        <div>
          <h3
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#E5E7EB",
              textTransform: "uppercase",
              letterSpacing: "0.15em",
              margin: "0 0 16px 0",
              fontFamily: "Inter, system-ui, sans-serif",
            }}
          >
            Connect
            <div 
              style={{
                width: "32px",
                height: "3px",
                background: "linear-gradient(90deg, #00E6E6, #00B8D9)",
                marginTop: "6px",
                borderRadius: "2px",
                boxShadow: "0 2px 8px rgba(0, 230, 230, 0.3)",
              }}
            />
          </h3>
          
          {/* Contact Info */}
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <div>
              <div style={{
                fontSize: "12px",
                color: "#94A3B8",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                marginBottom: "4px",
                fontFamily: "Inter, system-ui, sans-serif",
                fontWeight: "600",
              }}>
                Email
              </div>
              <a
                href="mailto:Support@chilltreebotanicals.com"
                style={{
                  color: "#E5E7EB",
                  textDecoration: "none",
                  fontSize: "15px",
                  fontFamily: "Inter, system-ui, sans-serif",
                  fontWeight: "500",
                  transition: "all 0.3s ease",
                  padding: "4px 0",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#00E6E6";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#E5E7EB";
                }}
              >
                Support@chilltreebotanicals.com
              </a>
            </div>
            
            <div>
              <div style={{
                fontSize: "12px",
                color: "#94A3B8",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                marginBottom: "4px",
                fontFamily: "Inter, system-ui, sans-serif",
                fontWeight: "600",
              }}>
                Phone
              </div>
              <a
                href="tel:+12345678901"
                style={{
                  color: "#E5E7EB",
                  textDecoration: "none",
                  fontSize: "15px",
                  fontFamily: "Inter, system-ui, sans-serif",
                  fontWeight: "500",
                  transition: "all 0.3s ease",
                  padding: "4px 0",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#00E6E6";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#E5E7EB";
                }}
              >
                +1 (234) 567-8901
              </a>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="site-footer__follow">
          <h3
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#CBD5F5",
              textTransform: "uppercase",
              letterSpacing: "0.12em",
              margin: "0 0 12px 0",
              fontFamily: "Inter, system-ui, sans-serif",
            }}
          >
            Follow Us
            <div 
              style={{
                width: "20px",
                height: "2px",
                background: "#00E6E6",
                marginTop: "4px",
              }}
            />
          </h3>
          
          <div className="site-footer__social-grid">
            {[
              { name: "LinkedIn", image: "/chilltree-images/linkedin.png" },
              { name: "Instagram", image: "/chilltree-images/instagram.png" },
              { name: "YouTube", image: "/chilltree-images/youtube.png" },
              { name: "Facebook", image: "/chilltree-images/facebook.png" },
              { name: "X", image: "/chilltree-images/twitter.png" },
              { name: "TikTok", image: "/chilltree-images/tiktok.png" },
            ].map((social) => (
              <button
                key={social.name}
                type="button"
                className="site-footer__social-btn"
                style={{
                  borderRadius: "12px",
                  border: "2px solid rgba(0,255,255,0.3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  backgroundColor: "rgba(255,255,255,0.08)",
                  overflow: "hidden",
                  cursor: "pointer",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(0, 230, 230, 0.2)";
                  e.currentTarget.style.borderColor = "#00E6E6";
                  e.currentTarget.style.transform = "translateY(-4px) scale(1.1)";
                  e.currentTarget.style.boxShadow = "0 12px 28px rgba(0, 230, 230, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)";
                  e.currentTarget.style.borderColor = "rgba(0,255,255,0.3)";
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                aria-label={social.name}
              >
                <img
                  src={social.image}
                  alt={social.name}
                  className="site-footer__social-icon"
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Legal Bar */}
      <div className="site-footer__bottom">
        <div className="site-footer__bottom-inner">
          {/* Left: Legal Links */}
          <div className="site-footer__legal-links">
            <Link
              to="/privacy"
              style={{
                color: "#94A3B8",
                textDecoration: "none",
                fontSize: "14px",
                fontFamily: "Inter, system-ui, sans-serif",
                fontWeight: "500",
                transition: "all 0.3s ease",
                padding: "6px 0",
              }}
              onMouseEnter={(e) => {
                e.target.style.color = "#00E6E6";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#94A3B8";
              }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              style={{
                color: "#94A3B8",
                textDecoration: "none",
                fontSize: "14px",
                fontFamily: "Inter, system-ui, sans-serif",
                fontWeight: "500",
                transition: "all 0.3s ease",
                padding: "6px 0",
              }}
              onMouseEnter={(e) => {
                e.target.style.color = "#00E6E6";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#94A3B8";
              }}
            >
              Terms
            </Link>
          </div>

          {/* Center: Copyright */}
          <div style={{
            color: "#94A3B8",
            fontSize: "14px",
            fontFamily: "Inter, system-ui, sans-serif",
            fontWeight: "500",
          }}>
            © 2026 Chilltree
          </div>

          {/* Right: Tagline */}
          <div style={{
            color: "#94A3B8",
            fontSize: "14px",
            fontFamily: "Inter, system-ui, sans-serif",
            fontWeight: "500",
          }}>
            Elevating wellness experiences.
          </div>
        </div>
      </div>

      {/* Age Verification Modal - the shared component, so this matches the
          popup shown on entry exactly and centres on the viewport */}
      {showAgeModal && (
        <AgeVerification
          onVerified={handleAgeConfirm}
          onDecline={handleAgeDeny}
        />
      )}
    </footer>
  );
}


